import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/'); };

  const s = {
    nav: { background: 'rgba(250,247,242,0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #e2dbd0', position: 'sticky', top: 0, zIndex: 200 },
    inner: { maxWidth: 1160, margin: '0 auto', padding: '1rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    logo: { fontFamily: 'Fraunces, serif', fontSize: '1.4rem', fontWeight: 600, color: '#1c1814', textDecoration: 'none' },
    logoSpan: { color: '#c0392b' },
    links: { display: 'flex', gap: '2rem', alignItems: 'center' },
    link: { color: '#7a6f65', textDecoration: 'none', fontSize: '0.875rem', fontWeight: 500 },
    btn: { background: '#1c1814', color: '#faf7f2', padding: '0.5rem 1.2rem', borderRadius: 8, textDecoration: 'none', fontSize: '0.825rem', fontWeight: 600 },
    btnRed: { background: '#c0392b', color: '#fff', padding: '0.5rem 1.2rem', borderRadius: 8, textDecoration: 'none', fontSize: '0.825rem', fontWeight: 600 },
    userInfo: { fontSize: '0.82rem', color: '#7a6f65' },
    logoutBtn: { background: 'none', border: 'none', color: '#c0392b', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600, fontFamily: 'inherit' },
  };

  return (
    <nav style={s.nav}>
      <div style={s.inner}>
        <Link to="/" style={s.logo}>Layoff<span style={s.logoSpan}>Fund</span></Link>
        <div style={s.links}>
          <Link to="/campaigns" style={s.link}>Campaigns</Link>
          {user ? (
            <>
              <Link to="/dashboard" style={s.link}>Dashboard</Link>
              {user.role === 'ADMIN' && <Link to="/admin" style={s.link}>Admin</Link>}
              <span style={s.userInfo}>{user.fullName?.split(' ')[0]}</span>
              <button style={s.logoutBtn} onClick={handleLogout}>Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" style={s.link}>Log in</Link>
              <Link to="/create-campaign" style={s.btnRed}>Start campaign</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
